<template>
  <div class="mlog-wrap">
    <div class="mlog-bg" aria-hidden="true">
      <span class="mlog-blob mlog-blob--1"></span>
      <span class="mlog-blob mlog-blob--2"></span>
      <span class="mlog-grid"></span>
    </div>

    <div class="mlog-card">
      <div class="mlog-brand">
        <span class="mlog-logo"><i class="el-icon-monitor"></i></span>
        <h1 class="mlog-title">{{ mode === 'bootstrap' ? '初始化管理员' : '后台管理登录' }}</h1>
        <p class="mlog-sub">
          {{ mode === 'bootstrap' ? '系统首次启动，请先创建管理员账号' : '仅管理员账号可登录后台' }}
        </p>
      </div>

      <el-alert
        v-if="statusError"
        type="error"
        :title="statusError"
        :closable="false"
        show-icon
        class="mlog-alert"
      />
      <el-alert
        v-else-if="mode === 'bootstrap'"
        type="warning"
        title="系统尚未初始化，请先创建管理员账号"
        :closable="false"
        show-icon
        class="mlog-alert"
      />

      <el-form :model="form" class="mlog-form" @submit.native.prevent>
        <el-form-item>
          <el-input
            v-model="form.username"
            placeholder="管理员用户名"
            prefix-icon="el-icon-user"
            autocomplete="off"
            @keyup.enter.native="onSubmit"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="form.password"
            type="password"
            placeholder="密码"
            prefix-icon="el-icon-key"
            autocomplete="off"
            show-password
            @keyup.enter.native="onSubmit"
          />
        </el-form-item>

        <el-button class="mlog-submit" :loading="submitting" @click="onSubmit">
          {{ mode === 'bootstrap' ? '创建并继续' : '登 录' }}
        </el-button>
      </el-form>

      <div class="mlog-foot">
        <router-link to="/" class="mlog-home">返回前台首页</router-link>
        <button class="mlog-refresh" type="button" :disabled="statusLoading" @click="loadStatus">
          {{ statusLoading ? '检测中…' : '重新检测' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { UseUrl } from '../../utils/config'

export default {
  name: 'ManagerLogin',
  data() {
    return {
      mode: 'login',
      statusLoading: false,
      statusError: '',
      submitting: false,
      form: {
        username: '',
        password: ''
      }
    }
  },
  mounted() {
    this.loadStatus()
  },
  methods: {
    async loadStatus() {
      if (this.statusLoading) return
      this.statusLoading = true
      this.statusError = ''
      try {
        const res = await axios.post(UseUrl + '/manager/auth/status', {})
        const bootstrapped = !!res.data?.bootstrapped
        this.mode = bootstrapped ? 'login' : 'bootstrap'
      } catch (e) {
        const msg = e?.response?.data?.message || e?.message || '无法获取初始化状态'
        this.statusError = `无法获取初始化状态：${msg}`
        this.mode = 'login'
      } finally {
        this.statusLoading = false
      }
    },
    async onSubmit() {
      if (this.submitting) return
      const username = String(this.form.username || '').trim()
      const password = String(this.form.password || '').trim()
      if (!username || !password) {
        this.$message.warning('请输入用户名和密码')
        return
      }

      this.submitting = true
      try {
        if (this.mode === 'bootstrap') {
          const res = await axios.post(UseUrl + '/manager/auth/bootstrap', { username, password })
          if (res.data?.success) {
            this.$message.success(res.data?.message || '管理员创建成功')
            this.mode = 'login'
            this.form.password = ''
            return
          }
          this.$message.error(res.data?.message || '创建失败')
          return
        }

        const res = await axios.post(UseUrl + '/manager/auth/login', { username, password })
        if (!res.data?.success) {
          this.$message.error(res.data?.message || '登录失败')
          return
        }
        const token = res.data?.token || ''
        const user = res.data?.user || {}
        if (!token || user.role !== 'admin') {
          this.$message.error('该账号无权访问后台')
          return
        }
        localStorage.setItem('shicigame_token', token)
        localStorage.setItem('shicigame_user', JSON.stringify(user || {}))
        axios.defaults.headers.common.Authorization = 'Bearer ' + token
        window.dispatchEvent(new Event('shicigame-auth-changed'))

        const redirect = this.$route.query.redirect || '/manager/users'
        this.$router.replace(String(redirect))
      } catch (e) {
        const msg = e?.response?.data?.message || e?.message || '请求失败'
        this.$message.error(msg)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.mlog-wrap {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow-y: auto;
  background: radial-gradient(1200px 700px at 12% 8%, #16233d 0%, transparent 60%),
    radial-gradient(1000px 600px at 92% 92%, #232041 0%, transparent 55%),
    linear-gradient(160deg, #0a0f1d 0%, #101527 55%, #0a0f1d 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'PingFang SC',
    'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.mlog-bg {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
}
.mlog-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  opacity: 0.5;
}
.mlog-blob--1 {
  width: 420px;
  height: 420px;
  top: -130px;
  left: -90px;
  background: #3d5bff;
  animation: mlog-float 18s ease-in-out infinite;
}
.mlog-blob--2 {
  width: 360px;
  height: 360px;
  bottom: -150px;
  right: -70px;
  background: #8a4fff;
  animation: mlog-float 22s ease-in-out infinite reverse;
}
.mlog-grid {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(255, 255, 255, 0.045) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.045) 1px, transparent 1px);
  background-size: 46px 46px;
  mask-image: radial-gradient(circle at 50% 40%, #000 0%, transparent 78%);
  -webkit-mask-image: radial-gradient(circle at 50% 40%, #000 0%, transparent 78%);
}
@keyframes mlog-float {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(28px, -24px) scale(1.07);
  }
}

.mlog-card {
  position: relative;
  width: 400px;
  max-width: 100%;
  padding: 40px 36px 28px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(18px) saturate(140%);
  -webkit-backdrop-filter: blur(18px) saturate(140%);
  animation: mlog-rise 0.5s cubic-bezier(0.22, 1, 0.36, 1);
}
@keyframes mlog-rise {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mlog-brand {
  text-align: center;
  margin-bottom: 26px;
}
.mlog-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-bottom: 14px;
  border-radius: 15px;
  font-size: 24px;
  color: #fff;
  background: linear-gradient(135deg, #3d5bff 0%, #8a4fff 100%);
  box-shadow: 0 10px 26px rgba(61, 91, 255, 0.45);
}
.mlog-title {
  margin: 0;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 1px;
  color: #f2f5ff;
}
.mlog-sub {
  margin: 8px 0 0;
  font-size: 13px;
  color: rgba(226, 232, 255, 0.62);
}

.mlog-alert {
  margin-bottom: 16px;
  border-radius: 10px;
}

.mlog-submit {
  width: 100%;
  height: 44px;
  margin-top: 6px;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  letter-spacing: 3px;
  color: #fff;
  background: linear-gradient(135deg, #3d5bff 0%, #8a4fff 100%);
  box-shadow: 0 12px 26px rgba(61, 91, 255, 0.38);
  transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}
.mlog-submit:hover,
.mlog-submit:focus {
  color: #fff;
  filter: brightness(1.08);
  transform: translateY(-1px);
  box-shadow: 0 16px 30px rgba(61, 91, 255, 0.5);
}
.mlog-submit:active {
  transform: translateY(0);
}

.mlog-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 12px;
}
.mlog-home {
  color: rgba(226, 232, 255, 0.6);
  text-decoration: none;
  transition: color 0.15s ease;
}
.mlog-home:hover {
  color: #a9b8ff;
}
.mlog-refresh {
  padding: 0;
  border: none;
  background: none;
  color: rgba(226, 232, 255, 0.6);
  font-size: 12px;
  cursor: pointer;
  transition: color 0.15s ease;
}
.mlog-refresh:hover:not(:disabled) {
  color: #a9b8ff;
}
.mlog-refresh:disabled {
  cursor: default;
  opacity: 0.5;
}

/* Element UI 深色化 */
.mlog-form >>> .el-form-item {
  margin-bottom: 16px;
}
.mlog-form >>> .el-input__inner {
  height: 44px;
  line-height: 44px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.06);
  color: #eef2ff;
  padding-left: 40px;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.mlog-form >>> .el-input__inner::placeholder {
  color: rgba(226, 232, 255, 0.4);
}
.mlog-form >>> .el-input__inner:hover {
  border-color: rgba(255, 255, 255, 0.28);
}
.mlog-form >>> .el-input__inner:focus {
  border-color: #5d78ff;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 0 3px rgba(93, 120, 255, 0.18);
}
.mlog-form >>> .el-input__prefix {
  left: 12px;
  color: rgba(226, 232, 255, 0.5);
}
.mlog-form >>> .el-input__suffix {
  color: rgba(226, 232, 255, 0.5);
}
.mlog-form >>> .el-input__icon {
  line-height: 44px;
}
.mlog-form >>> .el-input__inner:-webkit-autofill {
  -webkit-text-fill-color: #eef2ff;
  transition: background-color 100000s ease-in-out 0s;
}

@media (max-width: 480px) {
  .mlog-card {
    padding: 32px 22px 22px;
  }
  .mlog-title {
    font-size: 20px;
  }
}
</style>
